import {
  CustomerCrudType,
  CustomAxiosType,
  GetMemberParams,
  CustomAxiosSingleType,
  Customer,
  CustomerRegisterCrudType,
  DeleteMobility,
  CustomListType,
} from "../types/types";
import { client } from "./client";

const b6t = `NB6T`;

// 소유자 조회
export const getCustomer = async ({
  page,
  searchKey,
  area,
  sort,
  limit,
  groupId,
}: GetMemberParams) => {
  const response = await client.post<
    CustomAxiosType<CustomListType<Customer[]>>
  >(`/api/user` + b6t + `/get`, {
    page,
    searchKey,
    area,
    sort,
    limit,
    groupId,
  });

  return response.data.result;
};

// 소유자 조회 (전체)
export const getAllCustomer = async ({
  page,
  searchKey,
  area,
  sort,
  limit,
}: GetMemberParams) => {
  const response = await client.post<
    CustomAxiosType<CustomListType<Customer[]>>
  >(`/api/user` + b6t + `/get`, {
    page,
    searchKey,
    area,
    sort,
    limit,
  });
  return response.data.result;
};

// 소유자 삭제
export const deleteCustomer = async ({ seq }: DeleteMobility) => {
  const response = await client.post(`/api/user` + b6t + `/delete`, {
    seq,
  });
  return response.data;
};

// 소유자 상세 조회
export const getCustomerDetail = async ({ seq }: DeleteMobility) => {
  const response = await client.post<CustomAxiosType<Customer>>(
    `/api/user` + b6t + `/detail`,
    {
      seq,
    }
  );
  return response.data.result;
};

// 소유자 수정
export const putCustomerInfo = async ({
  seq,
  address,
  address_detail,
  name,
  id,
  pw,
  group_id,
  // birth,
  // sex,
  illness,
}: CustomerCrudType) => {
  const response = await client.post<CustomAxiosSingleType>(
    `/api/user` + b6t + `/patch`,
    {
      seq,
      address,
      address_detail,
      name,
      id,
      pw,
      group_id,
      // birth,
      // sex,
      illness,
    }
  );
  return response.data;
};

// 소유자 등록
export const postCustomer = async ({
  address,
  address_detail,
  name,
  id,
  pw,
  group_id,
  // birth,
  // sex,
  illness,
}: CustomerRegisterCrudType) => {
  const response = await client.post<CustomAxiosSingleType>(
    `/api/user` + b6t,
    {
      address,
      address_detail,
      name,
      id,
      pw,
      group_id,
      // birth,
      // sex,
      illness,
    }
  );
  return response.data;
};
